// extracted by mini-css-extract-plugin
module.exports = {"headerContainer":"Header_headerContainer__2gDdT","addWidgetButton":"Header_addWidgetButton__KqtgN","dashboardTabs":"Header_dashboardTabs__3XGNK","active":"Header_active__u0b2O"};